import { Component, Input } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [],
    templateUrl: './topbar.component.html',
    styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
    @Input() showButtons = true;
    constructor(public authService: AuthService) {}
}
